import SaleCreateEditPage from './SaleCreateEditPage';

export default SaleCreateEditPage;
